/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_TitleInputs */

const en_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you need to get hired`)
};

const de_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles, was du brauchst, um eingestellt zu werden`)
};

const fr_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ce dont tu as besoin pour décrocher un emploi`)
};

const es_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo lo que necesita para conseguir empleo`)
};

const it_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto ciò di cui hai bisogno per essere assunto`)
};

const nl_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles wat je nodig hebt om aangenomen te worden`)
};

const pl_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko, czego potrzebujesz, aby zostać zatrudnionym`)
};

const fi_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki mitä tarvitset työllistymiseen`)
};

const da_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alt hvad du har brug for at blive ansat`)
};

const sv_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allt du behöver för att bli anställd`)
};

/**
* | output |
* | --- |
* | "Everything you need to get hired" |
*
* @param {Landing_Features_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_features_title = /** @type {((inputs?: Landing_Features_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_features_title(inputs)
	if (locale === "fr") return fr_landing_features_title(inputs)
	if (locale === "es") return es_landing_features_title(inputs)
	if (locale === "it") return it_landing_features_title(inputs)
	if (locale === "nl") return nl_landing_features_title(inputs)
	if (locale === "pl") return pl_landing_features_title(inputs)
	if (locale === "fi") return fi_landing_features_title(inputs)
	if (locale === "da") return da_landing_features_title(inputs)
	if (locale === "sv") return sv_landing_features_title(inputs)
	return en_landing_features_title(inputs)
});